import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DeletePairAssignmentsInputClass;
function DeletePairAssignmentsInput() {
  if (DeletePairAssignmentsInputClass === VOID) {
    class $ {
      constructor(partyId, pairingSetId) {
        this.z6o_1 = partyId;
        this.a6p_1 = pairingSetId;
      }
      toString() {
        return 'DeletePairAssignmentsInput(partyId=' + this.z6o_1.toString() + ', pairingSetId=' + this.a6p_1.toString() + ')';
      }
      hashCode() {
        var result = this.z6o_1.hashCode();
        result = imul(result, 31) + this.a6p_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeletePairAssignmentsInput()))
          return false;
        if (!this.z6o_1.equals(other.z6o_1))
          return false;
        if (!this.a6p_1.equals(other.a6p_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeletePairAssignmentsInput');
    DeletePairAssignmentsInputClass = $;
  }
  return DeletePairAssignmentsInputClass;
}
//region block: exports
export {
  DeletePairAssignmentsInput as DeletePairAssignmentsInput11fmeg9pssfu8,
};
//endregion

//# sourceMappingURL=DeletePairAssignmentsInput.mjs.map
